// The tooling lifecycle categories TMG's services span, and who each item serves.
export type Audience = 'oem' | 'tier1' | 'both';

export type ServiceItem = {
  text: string;
  audience: Audience;
};

export type ServiceCategory = {
  id: 'digitize' | 'move-store' | 'manage' | 'comply' | 'dispose' | 'recover';
  title: string;
  items: ServiceItem[];
};

export const serviceCategories: ServiceCategory[] = [
  {
    id: 'digitize',
    title: 'Digitize',
    items: [{ text: 'Supply chain digitization of OEM tooling and equipment', audience: 'both' }],
  },
  {
    id: 'move-store',
    title: 'Move, Store',
    items: [
      { text: 'Tool and equipment moves', audience: 'both' },
      { text: 'Tool & equipment warehousing', audience: 'both' },
    ],
  },
  {
    id: 'manage',
    title: 'Manage',
    items: [
      { text: 'Service Tool Part Supply', audience: 'both' },
      { text: 'Confirmation Audit', audience: 'oem' },
      { text: 'Lifecycle Management', audience: 'tier1' },
    ],
  },
  {
    id: 'comply',
    title: 'Comply',
    items: [
      { text: 'Manufacturing Origin Documentation', audience: 'oem' },
      { text: 'Supplier Origin Certification', audience: 'tier1' },
      { text: 'Tariff Exposure Assessment', audience: 'both' },
    ],
  },
  {
    id: 'dispose',
    title: 'Dispose',
    items: [
      { text: 'Service tool disposition reviews', audience: 'oem' },
      { text: 'Disposition request development and approval', audience: 'both' },
    ],
  },
  {
    id: 'recover',
    title: 'Recover',
    items: [
      { text: 'Scrap Bidding', audience: 'both' },
      { text: 'Processing and Recycling', audience: 'both' },
      { text: 'Asset Sales', audience: 'both' },
    ],
  },
];
